// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Cookies from 'js-cookie'

import Element from 'element-ui'
import './styles/element-variables.scss'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import './styles/mint-variables.scss'
import waterfall from 'vue-waterfall2'
import lang from './utils/zh-cn.js'
import * as qiniu from 'qiniu-js'

Vue.use(Element)
Vue.use(Mint)
Vue.use(waterfall)
Vue.use(lang)
Vue.use(qiniu)

import './icons' // svg图标目录
import 'animate.css';

import './styles/index.scss'
//import './styles/form.scss'
Vue.config.productionTip = false

import router from './router'
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title// + '_Camelliae'
	}
    next();
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js